/**
 * Whether the signed-in staff member may sell a gift card
 * (`giftCards.canSellGiftCards`, configurable per role in Settings →
 * Permissions; on for every role by default).
 *
 * Only an explicit `false` hides the sale entry points: an older backend that
 * doesn't send the key keeps selling available, and the backend enforces the
 * permission on both sale routes either way.
 *
 * Usage:
 *   const canSellGiftCards = useCanSellGiftCards();
 *   {giftCardsEnabled && canSellGiftCards && <SellGiftCardButton />}
 */

import usePermissions from "./usePermissions";

export function useCanSellGiftCards(): boolean {
  return usePermissions().giftCards?.canSellGiftCards !== false;
}

export default useCanSellGiftCards;
